import { getkwargs } from "../../utilities/functions";
import { onChange } from "../onchange";

export const onChangeSelectContact = async ({
  id = [],
  values = {},
  keyChange = "country_id",
  context,
  company_id,
  defaulChange,
  model = "res.partner",
}) => {
  // console.log("id", id, company_id);
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [id, values, keyChange, defaulChange],
      model,
      method: "onchange",
      ...getkwargs({ company_id, context, model, view_type: "form" }),
    },
  });
  const response = await onChange(raw, model);
  return JSON.parse(response);
};
